import { ICharacter } from "../types";
import { resolveImage } from "../util/util";

export const Disarray: ICharacter = {
  id: "disarray",
  name: "Disarray",
  image: resolveImage("characters/disarray.png"),
};

export const Spinner: ICharacter = {
  id: "spinner",
  name: "Spinner",
  image: resolveImage("characters/spinner.png"),
};

export const Superphreak: ICharacter = {
  id: "superphreak",
  name: "Superphreak",
  image: resolveImage("characters/superphreak.png"),
};

export const Wintermutant: ICharacter = {
  id: "wintermutant",
  name: "Wintermutant",
  image: resolveImage("characters/wintermutant.png"),
};

export const Joana: ICharacter = {
  id: "joana",
  name: "Joana",
  image: resolveImage("characters/joana.png"),
};

export const Leo: ICharacter = {
  id: "leo",
  name: "Leo",
  image: resolveImage("characters/leo.png"),
};

export const Tsumara: ICharacter = {
  id: "tsumara",
  name: "Tsumara285",
  image: resolveImage("characters/tsumara.png"),
};

export const Kimoni: ICharacter = {
  id: "kimoni",
  name: "Kimoni",
  image: resolveImage("characters/kimoni.png"),
};

export const Minerva: ICharacter = {
  id: "minerva",
  name: "Minerva",
  image: resolveImage("characters/minerva.png"),
};
